import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your config/api.js

const EditLead = () => {
    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [followupDate, setFollowupDate] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('pending'); // Default status is "pending"
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { id } = useParams(); // Get lead ID from URL params
    const navigate = useNavigate();

    // Fetch the lead data when the component is mounted
    useEffect(() => {
        fetch(`${BASE_URL}oleads/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const lead = data.data;
                    setName(lead.name);
                    setNumber(lead.number);
                    setFollowupDate(lead.followup_date);
                    setDescription(lead.description);
                    setStatus(lead.status);
                } else {
                    setError('Failed to fetch lead data');
                }
            })
            .catch(err => {
                setError('Error fetching lead data');
                console.error('Error fetching lead data:', err);
            });
    }, [id]);

    // Handle input changes
    const handleNameChange = (e) => setName(e.target.value);
    const handleNumberChange = (e) => setNumber(e.target.value);
    const handleFollowupDateChange = (e) => setFollowupDate(e.target.value);
    const handleDescriptionChange = (e) => setDescription(e.target.value);
    const handleStatusChange = (e) => setStatus(e.target.value);

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true); // Start loading state

        // Prepare the data to be sent
        const updatedLead = {
            staff_id: 1, // Replace with dynamic staff ID (e.g., from auth context or localStorage)
            name,
            number,
            followup_date: followupDate,
            description,
            status,
        };

        // Send PUT request to update the lead
        fetch(`${BASE_URL}oleads/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedLead),
        })
        .then(response => response.json())
        .then(data => {
            setLoading(false);
            if (data.status === 1) {
                // Lead was updated successfully, navigate back to the leads list
                navigate('/OrderLeadsList');
            } else {
                setError('Failed to update lead');
            }
        })
        .catch(error => {
            setLoading(false);
            setError('Error updating lead');
            console.error('Error updating lead:', error);
        });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Lead</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Lead Form</h4>
                            </div>
                            <div className="card-body">
                                {/* Form for editing an existing lead */}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            placeholder="Enter lead's name"
                                            value={name}
                                            onChange={handleNameChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="number" className="form-label">Phone Number</label>
                                        <input
                                            type="text"
                                            id="number"
                                            className="form-control"
                                            placeholder="Enter lead's phone number"
                                            value={number}
                                            onChange={handleNumberChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="followupDate" className="form-label">Follow-up Date</label>
                                        <input
                                            type="date"
                                            id="followupDate"
                                            className="form-control"
                                            value={followupDate}
                                            onChange={handleFollowupDateChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            placeholder="Enter lead's description"
                                            value={description}
                                            onChange={handleDescriptionChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="status" className="form-label">Status</label>
                                        <select
                                            id="status"
                                            className="form-control"
                                            value={status}
                                            onChange={handleStatusChange}
                                        >
                                            <option value="pending">Pending</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>
                                    <div className="mb-3 text-center">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Submitting...' : 'Update Lead'}
                                        </button>
                                    </div>
                                </form>
                                {error && <div className="alert alert-danger">{error}</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditLead;
